module.exports = __webpack_public_path__ + "img/Skirt-Back-B3-Da-Fc-Ga-Hc-Ia.fb2edb69.png";